import { render } from "./ButtonExportPDF.vue?vue&type=template&id=71ba5a40"
import script from "./ButtonExportPDF.vue?vue&type=script&lang=js"
export * from "./ButtonExportPDF.vue?vue&type=script&lang=js"

import exportComponent from "d:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__